/** Branding for close-or-not style games (Blitz Close or Not, Family How Many?). */
export function getCloseOrNotBranding(gameType: string): {
  icon: string;
  title: string;
  shortTitle: string;
} {
  if (gameType === 'how-many') {
    return {
      icon: '🔢',
      title: 'How Many?',
      shortTitle: 'How Many',
    };
  }
  return {
    icon: '🎯',
    title: 'Close or Not?',
    shortTitle: 'Close or Not',
  };
}
